var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55549 10.6111V13.7222C8.55549 13.9285 8.47354 14.1263 8.32768 14.2722C8.18182 14.4181 7.98399 14.5 7.77771 14.5H1.55549C1.34921 14.5 1.15138 14.4181 1.00552 14.2722C0.859654 14.1263 0.77771 13.9285 0.77771 13.7222V2.83333C0.77771 2.62705 0.859654 2.42922 1.00552 2.28336C1.15138 2.1375 1.34921 2.05556 1.55549 2.05556H3.11104M4.6666 12.1667V12.1744M5.44438 0.5H13.2222V6.72222H10.8888L7.77771 8.27778V6.72222H5.44438V0.5Z",
    stroke: "var(--brand-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextRed);
export default __webpack_public_path__ + "static/media/text-red.c6799fa8bf6cec21ef27e6bf6bd4cad5.svg";
export { ForwardRef as ReactComponent };